export const transformNullIntoEmpty = (data, propsArr) => {
  let i;
  let newData = { ...data };
  for (i = 0; i < propsArr.length; ++i) {
    if (newData[propsArr[i]] === null || newData[propsArr[i]] === undefined) {
      newData[propsArr[i]] = '';
    }
  }
  return newData;
};

export const putMaskIntoValue = (data) => {
  return data
    .substring(0, 2)
    .concat('/')
    .concat(data.substring(2, 4))
    .concat('/')
    .concat(data.substring(4, 8));
};
